import { render } from "./NavList.vue?vue&type=template&id=43ac3f29&scoped=true"
import script from "./NavList.vue?vue&type=script&lang=js"
export * from "./NavList.vue?vue&type=script&lang=js"

import "./NavList.vue?vue&type=style&index=0&id=43ac3f29&lang=scss&scoped=true"

import exportComponent from "/Users/benjamin_nalo/Ben/portfolio-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ac3f29"]])

export default __exports__